import { render } from "./ItemLink.vue?vue&type=template&id=2623c5ee&ts=true"
import script from "./ItemLink.vue?vue&type=script&lang=ts"
export * from "./ItemLink.vue?vue&type=script&lang=ts"

import exportComponent from "/www/wwwroot/home/admin-tmp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__